import { EventEmitter, Injectable } from '@angular/core';

import { ReferenceValues } from '../models/reference-values.';


@Injectable({
    providedIn: 'root'
})
export class MonitoringService {

    dgeChanged: EventEmitter<number> = new EventEmitter();
    refreshChanged: EventEmitter<void> = new EventEmitter();
    referenceValuesChanged: EventEmitter<ReferenceValues> = new EventEmitter();
    assignedRulesChanged: EventEmitter<void> = new EventEmitter();

    notifyDgeChange(dge: number): void {
        this.dgeChanged.emit(dge);
    }

    notifyRefreshChange(): void {
        this.refreshChanged.emit();
    }

    notifyReferenceValuesChange(referenceValues: ReferenceValues): void {
        this.referenceValuesChanged.emit(referenceValues);
    }

    notifyAssignedRulesChange(): void {
        this.assignedRulesChanged.emit();
    }
}
